/**
 * Holds generic configurations for different locales
 */

import { UsPostcodeRegExp, GbPostcodeRegExp } from '@gaia-family/lib'

export enum SupportedCountryIsoCodes {
  GB = 'GB',
  US = 'US',
}

export enum SupportedUsStateIsoCodes {
  CT = 'CT',
}

export enum SupportedCurrencyIsoCodes {
  GBP = 'GBP',
  USD = 'USD',
}

export enum SupportedUtsLocales {
  enGB = 'en-GB',
  enUS = 'en-US',
}

export type I18nGeneralConfig = {
  locale: SupportedUtsLocales
  currency: SupportedCurrencyIsoCodes
  postcode: RegExp
  representativeClinicId?: string
}

export const gbGeneralConfig: I18nGeneralConfig = {
  locale: SupportedUtsLocales.enGB,
  currency: SupportedCurrencyIsoCodes.GBP,
  postcode: GbPostcodeRegExp,
  representativeClinicId: 'clv2jdedp000e0ljye3lq7elx',
}

export const usGeneralConfig: I18nGeneralConfig = {
  locale: SupportedUtsLocales.enUS,
  currency: SupportedCurrencyIsoCodes.USD,
  postcode: UsPostcodeRegExp,
}
